const hostname = location.hostname;
let ENV = "prd";
if (/-dev|localhost|^192|^172/.test(hostname)) {
  ENV = "stg";
} else if (/-stg/.test(tmpHost)) {
  ENV = "stg";
}

let lalaMallApi = "https://mp.huolala.cn/lala-mall/api";
let lalaMallAdminApi = "https://mp.huolala.cn/lala-mall/admin/api";
let lalaMallNotAdminApi = "https://mp.huolala.cn/lala-mall/api/";

if (ENV === "dev") {
  lalaMallApi = "https://mp-dev.huolala.cn/lala-mall/api";
  lalaMallAdminApi = "https://mp-dev.huolala.cn/lala-mall/admin/api";
  lalaMallNotAdminApi = "https://mp.huolala.cn/lala-mall/api/";
} else if (ENV === "stg") {
  lalaMallApi = "https://mp-stg.huolala.cn/lala-mall/api";
  lalaMallAdminApi = "https://mp-stg.huolala.cn/lala-mall/admin/api";
  lalaMallNotAdminApi = "https://mp-stg.huolala.cn/lala-mall/api/";
}

export { ENV, lalaMallApi, lalaMallAdminApi, lalaMallNotAdminApi };
